<template>
    <div class="page-content-ptb js-smartScroll noScroll">
        <div class="order scroll-container">
            <div class="route-info">
                <div class="route-name">
                    {{campaign.campaignName}}
                </div>

                <div class="route-ship">
                    {{campaign.campaignSubTitle}}
                </div>
                <div class="order-line"></div>
            </div>
            <div class="cabinItem-wrap">
                <div class="cabinItem active">
                    <div class="cabinItem-m ">
                        <div class="cabinItem-title">
                            <div class="cabinItem-title-num">
                                <div class="cabinItem-title-num-txt1">船票预订号:</div>
                                <div class="cabinItem-title-num-txt2">{{pageData.bookingId || '48小时内生成' }}</div>
                            </div>
                        </div>
                        <div class="cabinItem-box">
                            <div class="cabinItem-img">
                                <router-link :to="detailLink" class="external">
                                    <img class=""
                                        :src="campaign.campaignImage">
                                </router-link>
                            </div>
                            <div class="cabinItem-info">
                                <div class="cabinItem-info-title">
                                    <div class="cabinItem-info-title-l">{{pageData.lastName + pageData.firstName}}</div>
                                </div>
                                <div class="cabinItem-info-brief">{{pageData.gender == 'F' ? '女': '男'}}&nbsp;&nbsp;|&nbsp;&nbsp; {{pageData.dateOfBirth}}</div>

                                <div class="cabinItem-info-num ">
                                    {{pageData.telephone}}
                                </div>
                            </div>
                        </div>

                        <div class="cabinItem-price">
                            <span class="unit">¥</span>
                            {{pageData.amount}}
                        </div>

                    </div>
                   
                </div>
            </div>
        </div>
        <div class="common-box payMethod scroll-container">
            <div class="payMethod-cell" :class="{ active: paymentType=='MOBILE_ALIPAY'}" @click="paymentType='MOBILE_ALIPAY'">
                <div class="payMethod-cell-m">
                    <img src="https://resource.rcclchina.com.cn/RcclHP/alipay.png">
                    支付宝支付
                </div>
                <div class="payMethod-cell-hook">
                    <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon10.png">
                </div>
            </div>
            <div class="payMethod-cell" :class="{ active: paymentType=='H5_WECHAT_PAY'}" @click="paymentType='H5_WECHAT_PAY'">
                <div class="payMethod-cell-m">
                    <img src="https://resource.rcclchina.com.cn/content/weixinimg3.png">
                    微信支付
                </div>
                <div class="payMethod-cell-hook">
                    <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon10.png">
                </div>
            </div>
        </div>

        <div class="toPay-m">
            <div class="toPay-m-l">
                <div class="toPay-m-num"><span id="toPayNum">1</span>张订单</div>
                <div class="toPay-m-txt">应付总计:￥</div>
                <div class="toPay-m-price">{{pageData.amount}}</div>
            </div>
            <div class="toPay-m-r" @click="submitPayment">立即支付</div>
        </div>

    </div>
</template>

<script>
import api from '@/api'
import wechatHelper from '@/utilities/wechatHelper'
export default {
    name: "OpenBookingPay",
    data () {
        return {
            paymentType: 'MOBILE_ALIPAY',
            pageData: {}
        }
    },
    beforeMount() {
        this.$store.commit('SET_PAGE_TITLE', '支付订单')
        this.initPage()
    },
    mounted() {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: true})
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
    },
    methods: {
        async initPage () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return this.$router.push({ name: 'Login', query:{ 
                    returnUrl: encodeURIComponent(location.href)
                }})
            }

            const query = this.$router.currentRoute.query
            if (!query || !query.orderId || query.orderId == '') {
                return this.$router.go(-1)
            }

            const { success, data, errMsg } = await api.booking.openBookingPay({
                orderId: query.orderId,
                userName: userToken
            })
            if (!success) {
                if (errMsg && errMsg.length > 0) {
                    this.$alert.show(errMsg)
                }
                return this.$router.go(-1)
            }
            if (data.openBookingStatus > 0) {
                return this.$router.go(-1)
            }
            this.pageData = data
            if (this.isTui) {
                this.tuiCampaignHandler()
            }
        },
        tuiCampaignHandler () {
            if (!wechatHelper.isWeixinBrowser()) return

            const tuiWechatOpenId = this.$store.state.user.tuiWechatOpenId
            if (!tuiWechatOpenId || tuiWechatOpenId == '') {
                return wechatHelper.tuiWechatAuth()
            }
        },
        async submitPayment() {
            // this.$loading.show()
            // const userToken = this.$store.state.user.userToken
            let paymentType = this.paymentType + ''
            if (wechatHelper.isWeixinBrowser() && paymentType == 'H5_WECHAT_PAY') {
                paymentType = 'WECHAT_PAY'
            } 

            return location.href = `/Rccl.Booking/OpenBooking/PayByMethod`
                + `?orderId=${this.pageData.orderId}&payMethod=${paymentType}`
                + `&isTui=${this.isTui}&returnUrl=${encodeURIComponent(location.href)}`

            // let request = {
            //     orderId: this.pageData.orderId,
            //     userName: userToken,
            //     payMethod: paymentType,
            //     openId: this.$store.state.user.wechatOpenId
            // }
            // if (this.isTui) {
            //     request.openId = this.$store.state.user.tuiWechatOpenId
            // }
            // const { success, data, errMsg } = await api.booking.openBookingSubmitPay(request)
            // this.$loading.hide()
            // if (!success) {
            //     if (errMsg && errMsg.length > 0) {
            //         this.$alert.show(errMsg)
            //         return
            //     }
            // }
            // if (data.paymentUrl) {
            //     if (data.needRedirect) {
            //         return location.href = data.paymentUrl
            //     } else {
            //         this.$router.push({
            //             name: "OpenBookingPayByMethod",
            //             params: {
            //                 paymentContent: data
            //             },
            //             query: {
            //                 returnUrl: encodeURIComponent(location.href)
            //             }
            //         })
            //     }
            // }
        }
    },
    computed: {
        campaign () {
            return this.pageData.campaign || {}
        },
        detailLink () {
            return { name: "OpenBookingDetail", query: { orderId: this.pageData.orderId}}
        },
        isTui () {
            return this.campaign.platform == "TUI"
        }
    }
}
</script>

<style lang="less" scoped>
.page-content-ptb {
    padding-bottom: 49px;
    padding-top: 10px;
}
img {
    max-width: 100%;
    z-index: 99;
}

.order {
    width: 355px;
    margin: 10px auto 10px;
    padding: 0 10px;
    border-radius: 5px;
    background-color: #fff;
    border: 1px solid #FEBC10;
    border-top: 5px solid #FEBC10;
    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    .route-info {
        padding: 14px 0 0;
        .route-name {
            padding-bottom: 5px;
            font-size: 14px;
            line-height: 20px;
            color: #333;
            font-weight: bold;
        }
        .route-ship {
            font-size: 12px;
            line-height: 16px;
            color: #666;
        }
        .order-line {
            margin-top: 16px;
        }
    }
    .cabinItem {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        .cabinItem-m {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            padding-bottom: 7px;
            .cabinItem-title {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding: 12px 0;
                .cabinItem-title-num {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: bold;
                    .cabinItem-title-num-txt1 {
                        margin-right: 3px;
                        color: #4A90E2;
                    }
                    .cabinItem-title-num-txt2 {
                        margin-right: 10px;
                        color: #151515;
                    }
                }
            }
            .cabinItem-box {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                padding-bottom: 10px;
                .cabinItem-img {
                    -webkit-box-flex: 0;
                    -webkit-flex: none;
                    -moz-box-flex: 0;
                    -ms-flex: none;
                    flex: none;
                    width: 100px;
                    margin-right: 12px;
                }
                .cabinItem-info {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    .cabinItem-info-title {
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -moz-box;
                        display: -ms-flexbox;
                        display: flex;
                        padding-top: 2px;
                        padding-bottom: 4px;
                        font-weight: bold;
                        .cabinItem-info-title-l {
                            -webkit-box-flex: 1;
                            -webkit-flex: 1;
                            -moz-box-flex: 1;
                            -ms-flex: 1;
                            flex: 1;
                            padding-right: 2px;
                            font-size: 12px;
                            line-height: 16px;
                            color: #333;
                        }
                    }
                    .cabinItem-info-brief {
                        padding-bottom: 4px;
                        font-size: 12px;
                        line-height: 16px;
                        color: #666;
                    }
                    .cabinItem-info-num {
                        padding-bottom: 20px;
                        font-size: 12px;
                        line-height: 16px;
                        color: #666;
                    }
                }
            }
            .cabinItem-price {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: end;
                -webkit-justify-content: flex-end;
                -moz-box-pack: end;
                -ms-flex-pack: end;
                justify-content: flex-end;
                -webkit-box-align: baseline;
                -webkit-align-items: baseline;
                -moz-box-align: baseline;
                -ms-flex-align: baseline;
                align-items: baseline;
                padding-bottom: 5px;
                font-size: 15px;
                line-height: 20px;
                color: #FF5055;
                font-weight: bold;
                span {
                    display: block;
                    margin-right: 3px;
                    font-size: 12px;
                }
            }
        }
    }
}
.order-line {
    width: 100%;
    height: 1px;
    background: url(https://resource.rcclchina.com.cn/userCenter/line.png) repeat-x;
    -webkit-background-size: auto 100%;
    -o-background-size: auto 100%;
    background-size: auto 100%;
}

.common-box {
    margin-bottom: 10px;
    padding: 0 20px;
    background-color: #fff;
    .payMethod-cell {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        height: 58px;
        border-bottom: 1px solid #E5E5E5;
        .payMethod-cell-m {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-size: 12px;
            line-height: 16px;
            color: #333;
            img {
                display: block;
                width: 27px;
                margin-right: 12px;
            }
        }
        .payMethod-cell-hook {
            -webkit-box-flex: 0;
            -webkit-flex: none;
            -moz-box-flex: 0;
            -ms-flex: none;
            flex: none;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            width: 15px;
            height: 15px;
            border: 1px solid #4A90E2;
            border-radius: 100%;
            img {
                display: none;
                width: 12px;
            }
        }
    }
    .payMethod-cell:last-child {
        border-bottom: none;
    }
    .payMethod-cell.active .payMethod-cell-hook {
        background-color: #4A90E2;
        img {
            display: block;
        }
    }
}

.toPay-m {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 49px;
    .toPay-m-l {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
        -ms-flex: none;
        flex: none;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 253px;
        padding: 0 20px;
        background-color: #4A90E2;
        color: #fff;
        .toPay-m-num {
            margin-right: 10px;
            padding-right: 7px;
            font-size: 14px;
            line-height: 16px;
            border-right: 1px solid #fff;
            span {
                font-size: 16px;
            }
        }
        .toPay-m-txt {
            font-size: 14px;
            line-height: 16px;
        }
        .toPay-m-price {
            font-size: 18px;
            line-height: 21px;
            font-weight: bold;
        }
    }
    .toPay-m-r {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -moz-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        font-size: 14px;
        line-height: 1;
        color: #454545;
        letter-spacing: 1px;
        font-weight: bold;
        background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
        background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
        background: -moz-linear-gradient(left, #FEBC10, #FAD961);
        background: -o-linear-gradient(left, #FEBC10, #FAD961);
        background: linear-gradient(to right, #FEBC10, #FAD961);
    }
}
</style>